// extracted by mini-css-extract-plugin
module.exports = {"formRecoverPassword":"styles_formRecoverPassword__2UySu"};